import SectionWrapper from '@/components/feature/SectionWrapper';

const stats = [
  { value: '10+', label: 'Years Experience' },
  { value: '500+', label: 'Students Trained' },
  { value: '15+', label: 'Championships' },
];

export default function StatsSection() {
  return (
    <section className="relative z-10 bg-boxing-red">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-5 md:py-7">
        <SectionWrapper>
          <div className="grid grid-cols-3 divide-x divide-white/20">
            {stats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center text-center px-2 md:px-4">
                <span className="font-bebas text-3xl md:text-5xl lg:text-6xl text-white">
                  {stat.value}
                </span>
                <span className="font-oswald uppercase text-[10px] md:text-xs tracking-[2px] text-white/80 mt-0.5">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </SectionWrapper>
      </div>
    </section>
  );
}